import { evalDisplayExpression } from '@utils/documentUtils';
import { FormulaManager } from '@utils/managers/FormulaManager';

/**
 * Считает формулу заголовка (`nameFormula` блока или вкладки) в строку.
 *
 * Без `evalFormula` это подстановка значений полей в текст, с ним — JS-выражение
 * (значения подставляются литералами, поэтому кавычки не снимаем). Пустая строка
 * означает «имени нет» — вызывающий откатывается на статический `name`.
 */
export const evaluateNameFormula = async (
    manager: FormulaManager,
    isEdit: boolean,
    isNew: boolean,
    evalFormula?: boolean,
    values?: unknown[],
): Promise<string> => {
    const replaced = await manager.ReplaceFormulaValues(isEdit, isNew, values as any[] | undefined, !evalFormula);
    if (!replaced) {
        return '';
    }

    return evalFormula ? evalDisplayExpression(replaced) : replaced;
};
